export enum SchedulesDAndHGridType {
    scheduleDs = 'scheduleDs',
    antennas = 'antennas',
    frequencies = 'frequencies',
}
